// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute } from '@tanstack/react-router';

// material ui icons
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import WavingHandRoundedIcon from '@mui/icons-material/WavingHandRounded';

// material ui
import { Box, Button, Divider, Paper, Stack, Typography } from '@mui/material';

export const Route = createFileRoute('/$accountId/_user/missing-service')({
  component: MissingServicePage,
});

function MissingServicePage() {
  const { t } = useTranslation('missing-service');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        p: 3,
      }}
    >
      <Paper
        variant="outlined"
        sx={{ maxWidth: 560, width: '100%', p: 5, textAlign: 'center' }}
      >
        <Stack alignItems="center" spacing={3}>
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              bgcolor: 'action.hover',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LockOutlinedIcon sx={{ fontSize: 36, color: 'text.secondary' }} />
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              {t('title', { defaultValue: 'Service not available' })}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t('description', {
                defaultValue:
                  "Your account doesn't have access to this service. If you believe this is a mistake, or if you'd like to learn more about getting access, please contact us.",
              })}
            </Typography>
          </Box>

          <Divider flexItem />

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            width="100%"
          >
            <Button
              fullWidth
              variant="outlined"
              startIcon={<EmailOutlinedIcon />}
              target="_blank"
              href="https://www.remoni.com/contact/"
            >
              {t('report_mistake', { defaultValue: 'Report a mistake' })}
            </Button>
            <Button
              fullWidth
              variant="contained"
              startIcon={<WavingHandRoundedIcon />}
              href="https://www.remoni.com/contact/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('get_offer', { defaultValue: 'Get an offer' })}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
